'use strict';

const _ = require('lodash');

module.exports = {
  getTags: function(object) {
    if (object.tags && object.tags.length) {
      return object.tags;
    }
    return ['all'];
  },

  matchTags: function(object1, object2) {
    const object1Tags = this.getTags(object1);
    const object2Tags = this.getTags(object2);

    const match = _.intersection(object1Tags, object2Tags);

    return ! _.isEmpty(match);
  },

}
